{
    "0x0000000000000000000000000000000000000001": "0x1",
    "0x0000000000000000000000000000000000000002": "0x1",
    "0x0000000000000000000000000000000000000003": "0x1",
    "0x0000000000000000000000000000000000000004": "0x1",
    "0x00521965e7bd230323c423d96c657db5b79d099f": "0x100000000000000000000000000000000000000000000000000"
}
